import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const goSection = (id) => {
    if (isHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  };

  const navLinks    = [['hero','Home'],['about','About'],['services','Services'],['why','Why Us'],['team','Team'],['contact','Contact']];
  const serviceLinks = ['Data Research','Information Mgmt.','Digital Services','Documentation','Automation','Consulting'];

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-gold-line" />

        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-brand-name">KELWA TECHNOLOGIES PRIVATE LIMITED</div>
            <div className="footer-brand-sub">Information Service Activities · India</div>
            <p className="footer-brand-desc">
              Delivering innovative information service solutions that empower organisations
              to thrive in a knowledge-driven economy.
            </p>
          </div>

          <div>
            <div className="footer-col-title">Navigation</div>
            <ul className="footer-links">
              {navLinks.map(([id, label]) => (
                <li key={id}><a onClick={() => goSection(id)}>{label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="footer-col-title">Services</div>
            <ul className="footer-links">
              {serviceLinks.map(s => (
                <li key={s}><a onClick={() => goSection('services')}>{s}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="footer-col-title">Legal</div>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
              <li><a>Refund Policy</a></li>
              <li><a>Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            © {new Date().getFullYear()} Kelwa Technologies Private Limited. All rights reserved.
          </p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
